import { useCallback } from "react";

import type { ReservationDetailUpdateNoShowStatusInput } from "@/lib/gql/__generated__/graphql";

import * as MutationRepository from "../../repository/mutation";

export const useUpdateReservationDetailUpdateNoShowStatus = (hotelID: string, reservationID: string) => {
	const { onUpdateReservationDetailUpdateNoShow: _onUpdateReservationDetailUpdateNoShow } =
		MutationRepository.useReservationDetailUpdateNoShowStatusUpdateMutation();

	/**
	 * 予約詳細のお客様のステータスの変更を実行
	 */
	const onUpdateReservationDetailUpdateNoShow = useCallback(
		(statusNoShow: ReservationDetailUpdateNoShowStatusInput["statusNoShow"]) => {
			const input: ReservationDetailUpdateNoShowStatusInput = {
				statusNoShow,
				hotelID,
				reservationID,
			} satisfies ReservationDetailUpdateNoShowStatusInput;
			_onUpdateReservationDetailUpdateNoShow(input);
		},
		[_onUpdateReservationDetailUpdateNoShow, hotelID, reservationID],
	);

	return {
		onUpdateReservationDetailUpdateNoShow,
	};
};
